import { getUsername,loginUser} from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'
import router from '../../router'
import { MessageBox, Message } from 'element-ui'
import cookies from 'js-cookie'

const getDefaultState = () => {
  return {
    token: localStorage.getItem('token'),
    name: localStorage.getItem('name'),
    avatar: localStorage.getItem('avatar'),
    userinfo: localStorage.getItem('userinfo'),
    config: '',
    type: localStorage.getItem('type'),
    links: localStorage.getItem('links'),
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
    localStorage.setItem('token', token)
  },
  SET_NAME: (state, name) => {
    state.name = name;
    localStorage.setItem('name', name)
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
    localStorage.setItem('avatar', avatar)
  },
  SET_USERINFO: (state, userinfo)=>{
    state.userinfo = userinfo
    localStorage.setItem('userinfo', userinfo)
  }
}

const actions = {
  userinfo({ commit }, user_id){
    // console.log('user_id',user_id)
    return new Promise((resolve, reject) => {
       
      userinfo({ user_id: user_id }).then(response => {
        
        var data = response.data;
        // console.log(data)
        var sdata = JSON.stringify(data)
        commit('SET_USERINFO',sdata)
        commit('SET_NAME', data.nickname)
        commit('SET_AVATAR', data.avatar)
        commit('SET_TOKEN', data.id)
        resolve()
      }).catch(error => {
        // console.log('error',error)
        reject(error)
      })
    })
  },
  // user login
  login({ commit }, userInfo) {
    const { loginName, loginPwd } = userInfo
    return new Promise((resolve, reject) => {
       
      loginUser({ loginName: loginName.trim(), loginPwd: loginPwd.trim() }).then(response => {
        
        var test = cookies.get('JSESSIONID');
        console.log('test',cookies(response))
        getUsername().then(response=>{
          var name = response.result;
          commit('SET_NAME',name);
          Message({
            message: '登录成功',
            type: 'success',
            duration: 1000
          })
          // this.$router.go(-1)
          router.go(-1);
        })
        return false;
        var data = response.data;
        Message({
          message: response.msg ,
          type: 'success',
          duration: 1000
        })
        // console.log(data)
        var sdata = JSON.stringify(data)
        // commit('SET_USERINFO',sdata)
        commit('SET_USERINFO',sdata)
        commit('SET_NAME', data.username)
        commit('SET_AVATAR', data.avatar)
        commit('SET_TOKEN', data.id)
        resolve()
      }).catch(error => {
        // console.log('error',error)
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) { 
    return new Promise((resolve, reject) => {
      var sdata ={
        user_id: state.id
      }
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      // logout(state.token).then(() => {
      //   removeToken() // must remove  token  first
      //   resetRouter()
      //   commit('RESET_STATE')
      //   resolve()
      // }).catch(error => {
      //   reject(error)
      // })
      // console.log('out')
      commit('SET_NAME','')
      // resetRouter()
      // removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/user.js